import { render, staticRenderFns } from "./MinionDetail.vue?vue&type=template&id=03e5fd8a&scoped=true&"
import script from "./MinionDetail.vue?vue&type=script&lang=js&"
export * from "./MinionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5fd8a",
  null
  
)

export default component.exports